import { Fragment } from "react";
import moment from "moment";

export function VersionWrapper({ data, current }) {
    return (
        <div className="sdr-versions">
            <div className="version-wrapper">
                <div className="version-details"><span className="version">v{data.version}</span> - {current ? moment.utc().format("MMM DD, YYYY") : data.date}</div>
                <div className="versions-links">
                    {data.overview_file_url && (
                    <Fragment>
                        {/* eslint-disable-next-line sentence-case/sentence-case */}
                        <a rel="noopener noreferrer" target="_blank" href={data.overview_file_url}>Scheduled Delivered Reports Overview (.pdf)</a>
                        <span className="divider">|</span>
                    </Fragment>
                    )}
                    { data.all_files_url && (
                    <Fragment>
                        <a rel="noopener noreferrer" target="_blank" href={data.all_files_url}>All files (compressed) (.zip)</a>
                        <span className="divider">|</span>
                    </Fragment>
                    )}
                    {data.sdr_spec_url && (
                    <Fragment>
                        <a rel="noopener noreferrer" target="_blank" href={data.sdr_spec_url}>SDR technical specs (.xlsx)</a>
                        <span className="divider">|</span>
                    </Fragment>
                    )}
                    {data.companion_file_url && (
                    <a rel="noopener noreferrer" target="_blank" href={data.companion_file_url}>Pazien normalized fields companion file (.xlsx)</a>
                    )}
                </div>
            </div>
    
        </div>
    );
}
